import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BirthdayDashboard from "./pages/BirthdayDashboard";
import DigitalSign from "./pages/DigitalSign";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="app-container">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BirthdayDashboard />} />
          <Route path="/display" element={<DigitalSign />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
